import { ButtonHTMLAttributes, FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import ArrowDownIcon from '@z-components/static/images/icons/Icon_Down.svg';

import styles from './SeeMoreIconButton.module.scss';

interface Props {
  className?: string;
  hasIcon?: boolean;
  onClick?: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  testId?: string;
  text?: string;
}

export const SeeMoreIconButton: FC<Props> = ({
  className = '',
  onClick = () => undefined,
  testId = '',
  text,
  hasIcon = true,
}) => {
  const { t } = useTranslation();
  const btnText = text ?? t('seeMore');

  return (
    <button
      className={classNames(styles['z-see-more-icon-button'], className)}
      onClick={onClick}
      data-testid={testId}
      data-cy={'see-more'}
    >
      {hasIcon && <ArrowDownIcon className={styles['z-see-more-icon-button-icon']} />}
      {btnText}
    </button>
  );
};

export default SeeMoreIconButton;
export type { Props as SeeMoreIconButtonProps };
